(function () {
  function init() {
    var $slider = $('.results-slider');
    if (!$slider.length || typeof $.fn.slick !== 'function') return;

    $slider.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      swipeToSlide: true,
      prevArrow: $('.results-slide .results-header__prev'),
      nextArrow: $('.results-slide .results-header__next'),
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
